module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trans_bg"
  }, [_c('div', {
    staticClass: "trans_ipad"
  }, [_c('div', {
    staticClass: "trans_center"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/trans/ipad_ok_landscape.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("請將裝置轉至直式"), _c('br'), _vm._v("體驗最佳瀏覽方式")])])]), _vm._v(" "), _c('div', {
    staticClass: "trans_iphone"
  }, [_c('div', {
    staticClass: "trans_center"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/trans/iphone_ok.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("請將裝置轉至直式"), _c('br'), _vm._v("體驗最佳瀏覽方式")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49b0f70c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RotateDetect.vue
// module id = 252
// module chunks = 0